import React from 'react';
import { Pagination } from "react-bootstrap";

class PaginationComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          key:1,
          arrIntervals:[]
        }
    }

    componentDidMount() {
      let arr = [];
      for(let i = 1; i <= this.props.intervals; i++) {
        arr.push(i);
      }
      this.setState({
        arrIntervals:arr
      });
    }

    componentDidUpdate() {
      if(this.state.key !== this.props.active) {
        this.setState({
          key:this.props.active
        });
      }
    }

    handleClickPaginationItem = (number) => {
      this.setState({
        key:number
      }, () => {
        this.props.handleClickPaginationItem(number);
      });
    }

    htmlPagination = () => {
      let active = this.props.active;
      let items = [];
      for (let number = 1; number <= this.props.intervals; number++) {
        items.push(
          <Pagination.Item key={number} active={number === active} onClick={ () => this.handleClickPaginationItem(number)}>
            {number}
          </Pagination.Item>,
        );
      }
      return items;
    }

    htmlPaginationComplex = () => {
      return (
      <>
        {this.state.key > 1 &&
          <>
          <Pagination.First onClick={ () => this.handleClickPaginationItem(1)} />
          <Pagination.Prev onClick={ () => this.handleClickPaginationItem(this.state.key - 1)} />
          </>
        }

        {this.htmlPaginationBodyComplex()}
        
        {this.state.key < this.props.intervals &&
          <>
          <Pagination.Next onClick={ () => this.handleClickPaginationItem(this.state.key + 1)} />
          <Pagination.Last onClick={ () => this.handleClickPaginationItem(this.props.intervals)} />
          </>
        }
      </>
      );
    }

    htmlPaginationBodyComplex = () => {
      let paginationIntervals = 6;
      let arrIntervals = JSON.parse(JSON.stringify(this.state.arrIntervals));

      // [arrLeft] [arrLeft] [arrLeft] [key] [arrRight] [arrRight] [arrRight]

      // left
      let arrRightLen = this.props.intervals - this.state.key;
      let arrLeftExtra = 0;
      if(arrRightLen < paginationIntervals / 2) {
        arrLeftExtra = paginationIntervals / 2 - arrRightLen; 
      }

      let arrReverse = arrIntervals.reverse();
      let index = arrReverse.indexOf(this.state.key);
      let arrLeft = arrReverse.slice(index + 1, index + 1 + paginationIntervals/2 + arrLeftExtra);
      arrLeft = arrLeft.reverse();

      // right
      arrIntervals = JSON.parse(JSON.stringify(this.state.arrIntervals));
      index = arrIntervals.indexOf(this.state.key);
      let arrRight = arrIntervals.slice(index, index + 1 + (paginationIntervals - arrLeft.length)); // includes the key

      // merge left & right
      let arr = arrLeft.concat(arrRight);
      
      let html = arr.map( (item, index) => {
        return <Pagination.Item key={index} active={item === this.state.key} onClick={ () => this.handleClickPaginationItem(item)}>{item}</Pagination.Item>
      });

      return html;
    }

    render() {
      if(this.state.arrIntervals.length) {
        return (
          <div className="float-right">
            <Pagination size="sm">
            {this.htmlPaginationComplex()}
            </Pagination>
          </div>
        );
      } else {
        return <></>
      }
    }
}

export default PaginationComponent;